/**
 * Vendor Edit Basic Info Modal — zod schema.
 *
 * board2-#79 「地址格式改成一個textfield，丟到googlet拆分」
 * (page 2cb89adb-b34d-80ee-a729-d094a38c45cc): registered-address required
 * set is country + postcode + address (single full-address textfield).
 * stateId/cityId are UNVALIDATED passthrough — backend-parse OUTPUTS
 * (Google Maps split, simulated by the mocks). Replaces the legacy
 * editBasicInfoSchema (which validated no address requiredness and predates
 * the single-textfield entry group).
 *
 * Pure module (no react/antd deps) so the vitest contract suite can import
 * it in the node environment — mirrors the mockParseAddress pattern.
 */

import { z } from 'zod';

export const editBasicInfoFormSchema = z.object({
  // Contact Details
  phoneCountryCode: z.string().min(1, 'vendor.validation.countryCodeRequired'),
  phoneNumber: z
    .string()
    .min(1, 'vendor.validation.phoneRequired')
    .regex(/^\d{6,15}$/, 'vendor.validation.phoneFormat'),
  phoneExtension: z.string().optional().or(z.literal('')),
  email: z
    .string()
    .min(1, 'vendor.validation.emailRequired')
    .email('vendor.validation.emailInvalidFormat')
    .max(100, 'vendor.validation.emailMax'),
  web: z.string().optional().or(z.literal('')),
  fax: z.string().optional().or(z.literal('')),

  // Registered Location — required set (board2-#79)
  countryId: z
    .number()
    .nullable()
    .refine((v) => v !== null && v > 0, 'vendor.validation.countryRequired'),
  postcode: z.string().min(1, 'vendor.validation.postcodeRequired'),
  address: z.string().min(1, 'vendor.validation.addressRequired'),

  // Backend-parse OUTPUTS — passthrough only, never validated in the form
  stateId: z.number().nullable(),
  stateName: z.string(),
  cityId: z.number().nullable(),
  cityName: z.string(),

  // Additional Information (passthrough so the resolver does not strip them)
  salesRepresentativeIds: z.array(z.number()).optional(),
  primaryPort: z.string().optional().or(z.literal('')),
});

export type EditBasicInfoFormData = z.infer<typeof editBasicInfoFormSchema>;
